import React from 'react';

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path d="M690.001-90v-120.001h-120v-59.998h120v-120h59.998v120h120v59.998h-120v120h-59.998zm-477.692-90.001q-30.308 0-51.308-21t-21-51.308v-455.382q0-30.308 21-51.308t51.308-21h55.385v-84.615h61.537v84.615h223.076v-84.615h59.999v84.615h55.385q30.308 0 51.308 21t21 51.308v236.307q-15-1.846-30-1.846-14.999 0-29.999 1.846v-76.307H200v295.382q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846H485.77q0 15 1.846 29.999 1.846 15 6.769 30H212.309zM200-607.69h480v-100.001q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H212.309q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v100.001zm0 0V-720v112.31z"></path>
    </svg>
  );
}

export default Icon;
